export default {"src":"/_next/static/media/greenTick.ffbcbd41.svg","height":169,"width":217,"blurWidth":0,"blurHeight":0};